(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('EditEventController', EditEventController);

  function EditEventController($state, $stateParams, Flash, eventService, formErrorsService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.deleteEvent = deleteEvent;
    vm.event = {};
    vm.eventForm = {};
    vm.sessionService = sessionService;
    vm.updateEvent = updateEvent;

    activate();

    function activate() {
      getEvent();
    }

    function deleteEvent() {
      angular.element('#deleteEventModal').modal('hide');
      eventService(sessionService.getAuthToken()).delete({id: $stateParams.id}, _deleteEventSuccess, _deleteEventFailure);
    }

    function getEvent() {
      eventService(sessionService.getAuthToken()).get({id: $stateParams.id}, (response) => vm.event = response);
    }

    function updateEvent() {
      eventService(sessionService.getAuthToken()).update({id: $stateParams.id}, vm.event, _updateEventSuccess, _updateEventFailure);
    }

    function _deleteEventSuccess() {
      $state.go('application.compliance_services.calendar');
      Flash.create('success', 'The event was successfully deleted.');
    }

    function _deleteEventFailure() {
      Flash.create('danger', 'An error occurred delete the event. Please try again later.');
    }

    function _updateEventSuccess() {
      Flash.create('success', 'The event was successfully updated.');
    }

    function _updateEventFailure(response) {
      Flash.create('danger', 'An error occurred updating the event. Please correct the errors on the form and resubmit.');
      vm.setFormErrors(vm.eventForm, response);
    }
  }
})();
